import { render, staticRenderFns } from "./treatments-selection.vue?vue&type=template&id=3a12703b"
import script from "./treatments-selection.vue?vue&type=script&lang=ts"
export * from "./treatments-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports